import React, { useCallback, useEffect, useMemo, useState } from 'react'
import numberFormatter from 'src/utils/numberFormatter';
import { numberFormat } from 'highcharts';
import { getDaysLookup, getProgramWiseTopUpChart } from '../api';
import LineChart from '../lineChart';
import SelectInput from 'src/components/shared/selectInput';
import Loader from 'src/components/loader.component';
import apiCalls from 'src/api/apiCalls';
import { Alert } from 'antd';

const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};

const otherOptions = {
    title: {
        text: '',
    },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = 'USDT' } = numberFormatter(this.y)
            return `<b>${numberFormat(value, 2, '.', ',')}${suffix} USDT</b>`;
        }
    },
    xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            formatter: function () {
                const text = this.value,
                    formatted = text.length > 15 ? text.substring(0, 12) + '...' : text;
                return '<div title="' + text + '">' + formatted + '</div>';
            },
            useHTML: true,
            style: {
                color: '#FFFFFF'
            }
        }
    },
    yAxis: {
        title: {
            text: `<span class="text-valueColor">USDT</span>`,
            useHTML: true
        },
        labels: {
            style: {
                color: '#FFFFFF'
            },
            formatter: function () {
                return `${numberFormat(this.value, 2, '.', ',')}`;
            }
        }
    },
    lang: {
        thousandsSep: ','
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false,
    },
}

const ProgramGraph = ({ program }) => {
    const [days, setDays] = useState(null)
    const [filters, setFilters] = useState(null)
    const [gettingDays, setGettingDays] = useState(false);
    const [error, setError] = useState(null)

    useEffect(() => {
        setGettingDays(true)
        getDays()
    }, [])

    const getDays = async () => {
        try {
            const response = await getDaysLookup();
            if (response.ok) {
                setDays(response.data["Graph"])
                setFilters({ days: response.data["Graph"]?.[0]?.name })
            } else {
                setError(apiCalls.isErrorDispaly(response))
            }
        } catch (errorMsg) {
            setError(apiCalls.isErrorDispaly(errorMsg))
        } finally {
            setGettingDays(false)
        }
    }

    const handleFilterChange = useCallback((value) => {
        setFilters((prev) => ({ ...prev, "days": value }))
    }, [])

    const fetchParams = useMemo(() => {
        return [program.id, filters?.days?.replace(/\D/g, '')];
    }, [filters, program.id])

    const closeError = useCallback(() => {
        setError(null)
    }, [])

    return (<>
        <div className="">
            {error && <Alert
                className='mb-2'
                type="error"
                description={error}
                onClose={closeError}
                showIcon
                closable
            />}
            {!filters && <Loader />}
            {filters &&
                <>
                    <div className='flex justify-between items-center'>
                        <div className='md:w-40 ml-auto'><SelectInput className='text-whiteText' options={days} fieldName="days" loading={gettingDays} defaultValue={filters?.days} value={filters?.days} onChange={handleFilterChange} allowClear={false} showSearch={false} /></div>
                    </div>
                    <LineChart
                        shouldFetch={true}
                        chartProperties={chartProps}
                        fetchMethod={getProgramWiseTopUpChart}
                        seriesKey={"transactionsModels"}
                        otherOptions={otherOptions}
                        axiskey={'yAxis'}
                        hasFetchParams={true}
                        fetchParams={fetchParams}
                        gettingFilters={gettingDays}
                    /></>}
        </div>
    </>);
}

export default ProgramGraph